export const hazardRiskScore = {
    LOW: 6,
    MEDIUM: 8,
    HIGH: 14,
};
